import React, { useState, useEffect } from "react";
import {
  getaxiosRequestWithToken,
  postaxiosRequestWithToken,
} from "../../api/api";
import { useNavigate } from "react-router-dom";
import { handleSession } from "../../api/apiSessionHandle";
import CommonSpinner from "../../services/commonSpinner";
import { FaSort, FaSortUp, FaSortDown, FaEdit } from "react-icons/fa";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import { showToast } from "../../services/toastifyservices";
import { FaFilter } from "react-icons/fa";
import { MultiSelect } from "react-multi-select-component";
import endpoints from "../../api/EndPoints";

const drafting = () => {
  const navigate = useNavigate();
  const today = new Date().toISOString().split("T")[0];
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [providers, setProviders] = useState([]);
  const [provider_id, setProviderId] = useState("");
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [appointmentStatuses, setAppointmentStatuses] = useState([]);
  const [appointmentStatusId, setAppointmentStatusId] = useState("");
  const [apptClaimData, setapptClaimData] = useState([]);
  const [selectedAppt, setSelectedAppt] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [initialStatus, setInitialStatus] = useState("");
  const [editedStatus, setEditedStatus] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [uniqueClaimStatus, setUniqueClaimStatus] = useState([]);
  const [uniqueApptStatus, setUniqueApptStatus] = useState([]);
  const [selectedClaimStatus, setselectedClaimStatus] = useState([]);
  const [selectedUniqueApptStatus, setselectedUniqueApptStatus] = useState([]);
  const [filteredClaimData, setFilteredClaimData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [remarks, setRemarks] = useState("");
  const [editedRemarks, setEditedRemarks] = useState("");

  useEffect(() => {
    if (filteredClaimData.length === 0) {
      setFilteredClaimData(apptClaimData);
    }
  }, [apptClaimData]);

  const Statuses = [
    { id: 1, name: "pending" },
    { id: 2, name: "sent" },
    { id: 3, name: "in_72_sent" },
    { id: 4, name: "onhold" },
    { id: 5, name: "unsigned_sent" },
  ];

  useEffect(() => {
    fetchProviders(navigate, setProviders, setError, setLoading);
    fetchAppointmentStatuses();
  }, [navigate]);
  const fetchProviders = async (
    navigate,
    setProviders,
    setError,
    setLoading
  ) => {
    try {
      const response = await getaxiosRequestWithToken(endpoints.FetchProvider);
      if (response.success) {
        //;
        setProviders(response.data.data || []);
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
    } finally {
      setLoading(false);
    }
  };
  const fetchAppointmentStatuses = async () => {
    try {
      const response = await getaxiosRequestWithToken(endpoints.AppointmentsStatus);
      if (response.success) {
        setAppointmentStatuses(response.data.appointment_status || []);
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
    }
  };

  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setUniqueApptStatus([]);
    setUniqueClaimStatus([]);
    setLoading(true);
    const Payload = {
      provider_id: provider_id,
      start_date: fromDate,
      end_date: toDate,
      // appointment_status_id: appointmentStatusId,
    };
    try {
      const response = await postaxiosRequestWithToken(
        endpoints.AppointmentsForClaimsStatus,
        Payload
      );
      if (response.success) {
        if (response.data.length === 0) {
          showToast("error", "No data found.");
        }
        setLoading(false);
        setapptClaimData(response.data.appointments || []);
        setFilteredClaimData(response.data.appointments || []);
        setUniqueClaimStatus(response.data.unique_claim_statuses || []);
        setUniqueApptStatus(
          response.data.unique_appointment_status_names || []
        );
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      setLoading(false);
      handleSession(error.response?.data, navigate);
    } finally {
      setLoading(false);
    }
  };
  const handleUpdate = (appt) => {
    setSelectedAppt(appt);
    setInitialStatus(appt.claim_status);
    setEditedStatus(appt.claim_status);
    setRemarks(appt.claim_comments);
    setEditedRemarks(appt.claim_comments);
    setShowModal(true);
  };

  const updateStatus = async () => {
    if (
      editedStatus === initialStatus &&
      editedRemarks === selectedAppt.claim_comments
    ) {
      setShowModal(false);
      return;
    }
    const Payload = {
      appointment_id: selectedAppt.appointment_id,
      claim_status: editedStatus,
      comments: editedRemarks,
    };
    try {
      const response = await postaxiosRequestWithToken(
        endpoints.UpdateAppointmentsClaimStatus,
        Payload
      );
      if (response.success) {
        showToast("success", response.message);
        setShowModal(false);
        handleSubmit();
        setRemarks("");
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
    }
  };

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    setEditedStatus(newStatus);
    setSelectedAppt((prev) => ({ ...prev, claim_status: newStatus }));
  };
  const handleRemarksChange = (e) => {
    const newRemarks = e.target.value;
    setEditedRemarks(newRemarks);
    //setSelectedAppt((prev) => ({ ...prev, claim_comments: newRemarks }))
  };

  const handleFromDateChange = (e) => {
    const newFromDate = e.target.value;
    setFromDate(newFromDate);

    if (toDate && newFromDate > toDate) {
      setToDate(today);
      showToast("error", "To Date cannot be earlier than From Date.");
    }
  };

  const handleToDateChange = (e) => {
    const newToDate = e.target.value;

    if (newToDate < fromDate) {
      setToDate(today);
      showToast("error", "To Date cannot be earlier than From Date.");
    } else {
      setToDate(newToDate);
    }
  };
  function formatDate(date) {
    const dateTimeStr = date;
    const datePart = dateTimeStr.split("T")[0];

    const [year, month, day] = datePart.split("-");

    return `${month}/${day}/${year}`;
  }
  function formatTime(time) {
    const dateTimeStr = time;
    const timePart = dateTimeStr.split("T")[1].split("-")[0];
    return timePart.substring(0, 5);
  }

  const handleFilter = () => {
    let filteredData = apptClaimData.filter((appt) => {
      const claimMatch =
        selectedClaimStatus.length === 0 ||
        selectedClaimStatus.includes(appt.claim_status);

      const apptMatch =
        selectedUniqueApptStatus.length === 0 ||
        selectedUniqueApptStatus.includes(appt.appointment_status_name);

      return claimMatch && apptMatch;
    });

    setFilteredClaimData(filteredData);
    setIsOpen(false);
  };
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedData = [...filteredClaimData].sort((a, b) => {
    if (sortConfig.key) {
      let valueA = a[sortConfig.key];
      let valueB = b[sortConfig.key];

      if (typeof valueA === "string") valueA = valueA.toLowerCase();
      if (typeof valueB === "string") valueB = valueB.toLowerCase();

      if (valueA < valueB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valueA > valueB) return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort />;
    return sortConfig.direction === "asc" ? <FaSortUp /> : <FaSortDown />;
  };
  return (
    <div className="mt-3 p-2 md:p-10 bg-gray-200">
      <div className="card">
        <span className="text-start font-bold ml-4 p-2 headingtext">
          Drafting
        </span>
      </div>
      <div className="card mt-3">
        <form onSubmit={handleSubmit}>
          <div className="card-body">
            <div className="row d-flex align-items-end items-center justify-center md-mb-5">
              <div className="col">
                <label
                  htmlFor="providerselect"
                  className="form-label font-bold"
                  style={{ minWidth: "100px" }}
                >
                  Provider <span className="text-red">*</span>
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  id="providerselect"
                  value={provider_id}
                  onChange={(e) => setProviderId(e.target.value)}
                  required
                >
                  <option value="">Select Provider Name</option>
                  {providers.map((provider) => (
                    <option key={provider.azz_id} value={provider.azz_id}>
                      {provider.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col">
                <label
                  htmlFor="datePicker"
                  className="form-label font-bold"
                  style={{ minWidth: "100px" }}
                >
                  From Date <span className="text-red">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="datePicker"
                  value={fromDate}
                  onChange={handleFromDateChange}
                  required
                />
              </div>

              <div className="col">
                <label
                  htmlFor="datePicker"
                  className="form-label font-bold"
                  style={{ minWidth: "100px" }}
                >
                  To Date <span className="text-red">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="datePicker"
                  value={toDate}
                  onChange={handleToDateChange}
                  required
                />
              </div>

              <div className="col mt-4 d-flex align-items-center">
                <button
                  className="btn btn-primary mt-2 fw-bold btncolor me-3"
                  type="submit"
                >
                  Search
                </button>
              </div>

              {uniqueClaimStatus.length > 0 && uniqueApptStatus.length > 0 && (
                <div className="col d-flex align-items-center justify-end cursor-default gap-3 md-mt-10 mt-2">
                  <div
                    className="bg-[#1e3a89] text-white px-3 py-2 rounded-pill d-flex align-items-center"
                    style={{ fontWeight: "bold", fontSize: "14px" }}
                  >
                    Total Patients:
                    <span
                      className="bg-white text-primary px-2 py-1 rounded-pill ms-2"
                      style={{ fontWeight: "bold" }}
                    >
                      {filteredClaimData.length}
                    </span>
                  </div>
                  <FaFilter
                    size={25}
                    color="#1e3a89"
                    className="mb-1 cursor-pointer"
                    onClick={() => setIsOpen(!isOpen)}
                  />
                </div>
              )}
            </div>
          </div>
        </form>

        <div className="mt-3">
          <div className="table-responsive">
            <table className="table table-striped table-hover">
              <thead className="table-primary">
                <tr>
                  {[
                    { key: "patient_id", label: "Patient Id" },
                    { key: "patient_name", label: "Patient Name" },
                    { key: "start_time", label: "Date" },
                    { key: "start_time", label: "Time" },
                    {
                      key: "appointment_status_name",
                      label: "Appointment Status",
                    },
                    { key: "claim_status", label: "Claim Status" },
                  ].map(({ key, label }) => (
                    <th
                      key={key}
                      onClick={() => handleSort(key)}
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          //justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span>{label}</span>
                        {getSortIcon(key)}
                      </div>
                    </th>
                  ))}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sortedData.length > 0 ? (
                  sortedData.map((appt) => (
                    <tr key={appt.appointment_id}>
                      <td>{appt.patient_id}</td>
                      <td>{appt.patient_name}</td>
                      <td>{formatDate(appt.start_time)}</td>
                      <td>{formatTime(appt.start_time)}</td>
                      <td>{appt.appointment_status_name}</td>
                      <td>{appt.claim_status}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => handleUpdate(appt)}
                        >
                          <FaEdit style={{ cursor: "pointer" }} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : apptClaimData.length > 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No data found for this search criteria.
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </div>

        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Update Claim Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedAppt ? (
              <div className="p-3 border rounded shadow-sm bg-light">
                <div className="row mb-3">
                  <div className="col-md-4">
                    <h6 className="fw-bold">Patient Id:</h6>
                    <p className="text-muted">{selectedAppt.patient_id}</p>
                  </div>
                  <div className="col-md-8">
                    <h6 className="fw-bold">Name:</h6>
                    <p className="text-muted">{selectedAppt.patient_name}</p>
                  </div>
                </div>

                <hr />

                <div className="row mb-3">
                  <div className="col-md-4">
                    <h6 className="fw-bold">Claim Status:</h6>
                    <Form.Select
                      value={editedStatus}
                      onChange={handleStatusChange}
                    >
                      {Statuses.map((status) => (
                        <option key={status.id} value={status.name}>
                          {status.name}
                        </option>
                      ))}
                    </Form.Select>
                  </div>

                  <div className="col-md-8">
                    <h6 className="fw-bold">Remarks:</h6>
                    <Form.Control
                      type="text"
                      placeholder="Enter remarks"
                      value={editedRemarks}
                      onChange={handleRemarksChange}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <p className="text-danger">No patient selected.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button
              variant="primary"
              //disabled={editedStatus === initialStatus && editedRemarks === selectedAppt.claim_comments}
              onClick={updateStatus}
            >
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={isOpen} onHide={() => setIsOpen(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Filter Data</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="p-3 border rounded shadow-sm bg-light">
              <div className="row mb-3">
                <div className="col-md-6">
                  <h6 className="fw-bold">Appointment Status:</h6>
                  <MultiSelect
                    options={uniqueApptStatus.map((status) => ({
                      label: status,
                      value: status,
                    }))}
                    value={selectedUniqueApptStatus.map((status) => ({
                      label: status,
                      value: status,
                    }))}
                    onChange={(selected) =>
                      setselectedUniqueApptStatus(selected.map((s) => s.value))
                    }
                    labelledBy="Select Appointment Status"
                    valueRenderer={(selected) =>
                      selected.length === uniqueApptStatus.length
                        ? uniqueApptStatus.join(", ")
                        : selected.map((s) => s.label).join(", ")
                    }
                  />
                </div>
                <div className="col-md-6">
                  <h6 className="fw-bold">Claim Status:</h6>
                  <MultiSelect
                    options={uniqueClaimStatus.map((status) => ({
                      label: status,
                      value: status,
                    }))}
                    value={selectedClaimStatus.map((status) => ({
                      label: status,
                      value: status,
                    }))}
                    onChange={(selected) =>
                      setselectedClaimStatus(selected.map((s) => s.value))
                    }
                    labelledBy="Select Claim Status"
                    valueRenderer={(selected) =>
                      selected.length === uniqueClaimStatus.length
                        ? uniqueClaimStatus.join(", ")
                        : selected.map((s) => s.label).join(", ")
                    }
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          ;
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setIsOpen(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handleFilter}>
              Filter
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      {loading && <CommonSpinner />}
    </div>
  );
};

export default drafting;
